/* istanbul ignore file */
import { useToken } from '@ori/auth';
import { SWRConfig } from '@ori/fetching';
import { ApiClientProvider } from '@ori/global-api-client-react';
import type { FC, PropsWithChildren } from 'react';

import { ConfigurationProvider, PersonalBeautyStoreProvider } from '../contexts';
import { useCookieToUrl } from '../hooks';
import type { AppConfiguration, RemoveQueryParameterCallback, SetQueryParameterCallback } from '../types';

export interface PbsAppProps {
  configuration: AppConfiguration;
  removeQueryParameter?: RemoveQueryParameterCallback | undefined;
  setQueryParameter?: SetQueryParameterCallback | undefined;
}

export const PbsApp: FC<PropsWithChildren<PbsAppProps>> = ({
  children,
  configuration,
  setQueryParameter,
  removeQueryParameter,
}) => {
  useCookieToUrl(setQueryParameter && removeQueryParameter ? { setQueryParameter, removeQueryParameter } : undefined);
  const { formattedToken } = useToken();

  return (
    <ConfigurationProvider value={configuration}>
      <SWRConfig
        value={{
          revalidateIfStale: false,
          revalidateOnFocus: false,
          revalidateOnReconnect: false,
          shouldRetryOnError: false,
          errorRetryCount: 0,
        }}
      >
        <ApiClientProvider
          baseUrl={configuration.globalApiUrl}
          tenant={configuration.tenant}
          language={configuration.currentLanguage}
          token={formattedToken}
        >
          <PersonalBeautyStoreProvider>{children}</PersonalBeautyStoreProvider>
        </ApiClientProvider>
      </SWRConfig>
    </ConfigurationProvider>
  );
};
